export default "<p>{{name}}</p>\r\n"